
















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import Route from './RouteInterface';

@Component({})
export default class Header extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  readonly routes!: Array<Route>;

  @Emit('newRoute')
  newRoute(): void {}

  async logout(): Promise<void> {
    await this.$store.dispatch('login/a_reset_token');
    this.$router.push('/login');
  }
}
